import React, { useState, useEffect, useMemo, useRef } from "react";
import * as XLSX from "xlsx";
import "./Beneficios360.css";
import {
  FiHeart,
  FiSearch,
  FiTrash2,
  FiDownload,
  FiUpload,
  FiEdit2,
  FiPackage,
  FiDollarSign,
  FiCreditCard,
  FiTrendingUp
} from "react-icons/fi";
import axios from "axios";
import { toast } from "react-toastify";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { es } from "date-fns/locale";
import PageTitle from "../components/PageTitle";

const CAMPOS_OBLIGATORIOS_EXCEL = [
  "CÉDULA",
  "ASOCIADO",
  "EMPRESA",
  "CIUDAD",
  "COSTOS",
  "FECHA",
  "ÁREA",
  "TIPO",
  "PROGRAMA",
  "INTERNO",   // ✅ CORRECTO
  "ENVÍO",
  "COMERCIAL",
];


const BENEFICIOS_MAP = {
  "Transferencia Solidaria": {
    Comerciales: [
      "34997 - Adicionales Honra Fúnebre",
      "30779 - Convenio Boletería",
      "31946 - Convenio Educación",
      "31950 - Convenio Hogar",
      "31947 - Convenio Movilidad",
      "30600 - Convenio Salud",
      "31948 - Convenio Seguros",
      "31949 - Convenio Tecnología",
      "31945 - Convenio Turismo",
      "33634 - Tienda Kómpralo",
    ],
  },

  "Más Beneficios": {
    Captaciones: [
      "32488 - Ahorro Navideño",
      "30577 - Ahorro Ordinario Socios",
      "30575 - Ahorro Vehículo",
      "30576 - Ahorro Vivienda",
      "30573 - Ahorro Voluntario",
    ],
    Cartera: [
      "32479 - Anticipo de Nomina",
      "32477 - Compra Vivienda",
      "32482 - Confianza",
      "32480 - Crédito de Convenio",
      "32487 - Crédito de Prima",
      "32485 - Crédito Exasociado",
      "32484 - Extraordinario",
      "32478 - Libre Inversión",
      "32483 - Libre Inversión Hipotecario",
      "32481 - Vehículo",
    ],
    Aportes: [
      "31027 - Revalorización Aportes",
    ],
  },

  "Educación y Recreación": {
    Sociales: [
      "30629 - Auxilio Bono Educativo",
      "30626 - Bono Educativo",
      "30627 - De Paseo por Colombia",
      "30625 - Excelencia Académica",
      "30628 - Historia de Colores",
      "31170 - Kit Escolar",
    ],
  },

  "Vivienda y Hogar": {
    Sociales: [
      "30619 - Adecuación del Hogar",
      "43404 - Bono Mercado",
      "30624 - Bono Servicios Públicos",
      "30623 - Dotando mi Casa",
      "30618 - Mejoramiento de Vivienda",
      "30620 - Remodelación de Vivienda",
      "30621 - Subsidio Vivienda Tasa y Escrituras",
      "30622 - Un Regalo para mi Familia",
    ],
  },

  "Salud y Vida": {
    Sociales: [
      "30615 - Auxilio Alquiler Equipos Médicos",
      "30617 - Auxilio Lentes Beneficiario",
      "30596 - Auxilio Lentes o Vacunación",
      "30612 - Auxilio para Medicamentos",
      "30614 - Auxilio para Terapias Físicas",
      "30598 - Auxilio por Discapacidad",
      "30613 - Auxilio Reembolso de Copago",
      "30616 - Sorteo Experiencias",
    ],
  },

  Obsequios: {
    Sociales: [
      "30638 - Obsequio Amor y Amistad",
      "30637 - Obsequio Cumpleaños",
      "30635 - Obsequio Grado Asociado",
      "30636 - Obsequio Matrimonio",
      "30634 - Obsequio Nacimiento Hijo Asociado",
      "30639 - Obsequio Navidad",
      "31171 - Somos Multiplicadores",
    ],
  },

  "Apoyo en Calamidad": {
    Sociales: [
      "30632 - Auxilio Fallecimiento Asociado",
      "30633 - Condonación Deuda Fallecimiento",
      "31169 - Donación Calamidad Asociado",
      "31172 - Mejoramiento Honra Fúnebre",
      "30631 - Reembolso de Viáticos",
      "30630 - Subsidio Honra Fúnebre",
    ],
  },
};

const token = localStorage.getItem("token");

const formatMoney = (num) =>
  new Intl.NumberFormat("es-CO", { minimumFractionDigits: 0 }).format(Number(num) || 0);

const excelDateToJS = (value) => {
  if (typeof value === "number") {
    const date = new Date((value - 25569) * 86400 * 1000);
    return date.toISOString().split("T")[0];
  }
  return value;
};

const CampoNumero = ({ label, name, value, onChange, error, readOnly = false }) => (
  <div className="campo">
    <label>{label}</label>
    <input
      type="number"
      name={name}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
    />
    {error && <small className="error-text">{error}</small>}
  </div>
);

function Beneficios360() {
  const [beneficios, setBeneficios] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [rangoFecha, setRangoFecha] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  const [showCalendar, setShowCalendar] = useState(false);

  // 🔹 NUEVO: Estados para la paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const registrosPorPagina = 25;

  const estructura = {
    CÉDULA: "",
    ASOCIADO: "",
    EMPRESA: "",
    CIUDAD: "",
    COSTOS: "",
    FECHA: "",
    ÁREA: "",
    TIPO: "",
    PROGRAMA: "",
    MONTO: "",
    ENVÍO: "",
    TOTAL: "",
    COMERCIAL: "",
    INTERNO: "",
    TRANSFERENCIA: "",
    COMPRA: "",
  };

  const [nuevoBeneficio, setNuevoBeneficio] = useState(estructura);
  const [errores, setErrores] = useState({});
  const [filtros, setFiltros] = useState({
    ciudad: "",
    empresa: "",
    area: "",
    tipo: "",
    programa: "",
    busqueda: "",
    fechaInicio: "",
    fechaFin: "",
  });

  // ====== CATÁLOGOS PARA FILTROS ======
  const areas = Object.keys(BENEFICIOS_MAP);

  const tipos = useMemo(() => {
    return [
      ...new Set(
        beneficios.map((b) => b.TIPO).filter(Boolean)
      ),
    ];
  }, [beneficios]);

  const programas = useMemo(() => {
    return [
      ...new Set(
        beneficios.map((b) => b.PROGRAMA).filter(Boolean)
      ),
    ];
  }, [beneficios]);

  // ✅ Cargar datos reales desde el backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/control-entregas`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (Array.isArray(res.data)) {
          const adaptados = res.data.map((b) => ({
            _id: b._id,
            "CÉDULA": b["Cédula"] || "",
            "ASOCIADO": b["Asociado"] || "",
            "EMPRESA": b["Empresa"] || "",
            "CIUDAD": b["Ciudad"] || "",
            "COSTOS": b["Costos"] || "",
            "FECHA": b["Fecha"] || "",
            "ÁREA": b["Área"] || "Sin área",
            "TIPO": b["Tipo"] || "Sin tipo",
            "PROGRAMA": b["Programa"] || "Sin programa",
            "MONTO": parseFloat((b["Monto"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
            "ENVÍO": parseFloat((b["Envío"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
            "TOTAL": parseFloat((b["Total"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
            "COMERCIAL": parseFloat((b["Comercial"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
            "INTERNO": parseFloat((b["Interno"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
            "TRANSFERENCIA": parseFloat((b["Transferencia"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
            "EXCEDENTES": parseFloat((b["Excedentes"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          }));
          setBeneficios(adaptados);
        }
      } catch (error) {
        console.error("❌ Error cargando beneficios:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".calendar-container")) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const opcionesUnicas = (campo) => {
    return [...new Set(beneficios.map((b) => b[campo]).filter(Boolean))]
      .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }));
  };

  const handleFiltro = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value });
    setPaginaActual(1); // reset al cambiar filtro
  };

  const resetFiltros = () => {
    setFiltros({
      ciudad: "",
      empresa: "",
      area: "",
      tipo: "",
      programa: "",
      busqueda: "",
      fechaInicio: "",
      fechaFin: "",
    });

    setRangoFecha([
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ]);

    setPaginaActual(1);
  };

  const handleSelectFecha = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    setRangoFecha([ranges.selection]);

    setFiltros((prev) => ({
      ...prev,
      fechaInicio: startDate ? startDate.toISOString().split("T")[0] : "",
      fechaFin: endDate ? endDate.toISOString().split("T")[0] : "",
    }));
  };

  const beneficiosFiltrados = useMemo(() => {
    return [...beneficios]
      .sort((a, b) => {
        if (!a._id || !b._id) return 0;
        return b._id.localeCompare(a._id);
      })
      .filter((b) => {
        const fecha = b.FECHA ? new Date(b.FECHA) : null;
        const inicio = filtros.fechaInicio ? new Date(filtros.fechaInicio) : null;
        const fin = filtros.fechaFin ? new Date(filtros.fechaFin) : null;

        return (
          (filtros.busqueda === "" ||
            b.ASOCIADO?.toLowerCase().includes(filtros.busqueda.toLowerCase()) ||
            b.CÉDULA?.toLowerCase().includes(filtros.busqueda.toLowerCase())) &&
          (filtros.ciudad === "" || b.CIUDAD === filtros.ciudad) &&
          (filtros.empresa === "" || b.EMPRESA === filtros.empresa) &&
          (filtros.area === "" || b.ÁREA === filtros.area) &&
          (filtros.tipo === "" || b.TIPO === filtros.tipo) &&
          (filtros.programa === "" || b.PROGRAMA === filtros.programa) &&

          // 🔥 FILTRO POR FECHA
          (!inicio || (fecha && fecha >= inicio)) &&
          (!fin || (fecha && fecha <= fin))
        );
      });
  }, [beneficios, filtros]);


  // 🔹 Paginación
  const totalPaginas = Math.ceil(beneficiosFiltrados.length / registrosPorPagina);
  const indiceInicio = (paginaActual - 1) * registrosPorPagina;
  const indiceFin = indiceInicio + registrosPorPagina;
  const registrosMostrados = beneficiosFiltrados.slice(indiceInicio, indiceFin);

  // ✅ Import masivo con preview
  const [showImportModal, setShowImportModal] = useState(false);
  const [importRows, setImportRows] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [erroresExcelModal, setErroresExcelModal] = useState([]);

  const [modoEdicion, setModoEdicion] = useState(false);

  // === KPI ===
  const totalBeneficios = beneficiosFiltrados.length;

  const inversionSocial = beneficiosFiltrados.reduce(
    (acc, b) => acc + (Number(b.TOTAL) || 0),
    0
  );

  const totalEnvio = beneficiosFiltrados.reduce(
    (acc, b) => acc + (Number(b["ENVÍO"]) || 0),
    0
  );

  const totalTransferencias = beneficiosFiltrados.reduce(
    (acc, b) => acc + (Number(b.TRANSFERENCIA) || 0),
    0
  );


  const nuevoRegistro = () => {
    setNuevoBeneficio(estructura);
    setModoEdicion(false);
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
    setNuevoBeneficio(estructura);
    setModoEdicion(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (errores[name]) {
      setErrores(prev => {
        const copia = { ...prev };
        delete copia[name];
        return copia;
      });
    }

    let actualizado = { ...nuevoBeneficio, [name]: value };

    if (name === "TIPO") {
      actualizado["ÁREA"] = "";
      actualizado.PROGRAMA = "";
    }

    if (name === "ÁREA") {
      actualizado.PROGRAMA = "";
    }

    const tipo = actualizado.TIPO;

    // 🔹 Normalizamos números
    const comercial = Number(actualizado.COMERCIAL) || 0;
    let transferencia = 0;
    let total = 0;

    // 🟢 SOCIALES (nuevo modelo)
    if (tipo === "Sociales") {
      const internoUI = Number(actualizado.INTERNO) || 0;
      const envioUI = Number(actualizado["ENVÍO"]) || 0;

      total = internoUI + envioUI;
      transferencia = total;

      actualizado.COMERCIAL = total;
    }



    // 🔵 COMERCIALES
    else if (tipo === "Comerciales") {
      const compra = Number(actualizado.COMPRA) || 0;

      actualizado.MONTO = 0;
      actualizado["ENVÍO"] = 0;
      actualizado.INTERNO = 0;

      total = 0;
      transferencia = Math.max(comercial - compra, 0);
    }


    // 🟣 APORTES / CAPTACIONES / CARTERA
    else if (
      tipo === "Aportes" ||
      tipo === "Captaciones" ||
      tipo === "Cartera"
    ) {
      actualizado.MONTO = 0;
      actualizado["ENVÍO"] = 0;
      actualizado.INTERNO = 0;
      actualizado.COMERCIAL = 0;
      total = 0;
      transferencia = Number(actualizado.TRANSFERENCIA) || 0;
    }

    actualizado.TOTAL = total;
    actualizado.TRANSFERENCIA = transferencia;

    setNuevoBeneficio(actualizado);
  };

  // ✅ Guardar beneficio en backend
  const guardarBeneficio = async () => {
    try {
      const payload = {
        cedula: nuevoBeneficio["CÉDULA"],
        asociado: nuevoBeneficio["ASOCIADO"],
        empresa: nuevoBeneficio["EMPRESA"],
        ciudad: nuevoBeneficio["CIUDAD"],
        costos: Number(nuevoBeneficio["COSTOS"]) || 0,
        fecha: nuevoBeneficio["FECHA"],
        area: nuevoBeneficio["ÁREA"],
        tipo: nuevoBeneficio["TIPO"],
        programa: nuevoBeneficio["PROGRAMA"],
        monto: Number(nuevoBeneficio["MONTO"]) || 0,
        envio: Number(nuevoBeneficio["ENVÍO"]) || 0,
        total: Number(nuevoBeneficio["TOTAL"]) || 0,
        comercial: Number(nuevoBeneficio["COMERCIAL"]) || 0,
        interno: Number(nuevoBeneficio["INTERNO"]) || 0,
        transferencia: Number(nuevoBeneficio["TRANSFERENCIA"]) || 0,
        excedentes: Number(nuevoBeneficio["EXCEDENTES"]) || 0,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/control-entregas`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data) {
        // 🟣 AÑADIR _id QUE REGRESA MONGO
        setBeneficios([...beneficios, { ...nuevoBeneficio, _id: res.data._id }]);

        toast.success("Beneficio registrado correctamente");
        cerrarModal();
      }
    } catch (error) {
      console.error("❌ Error al guardar beneficio:", error);
      toast.error("Error al guardar beneficio");
    }
  };


  // 🗑️ Eliminar beneficio
  const eliminarBeneficio = (id) => {
    setIdAEliminar(id);
    setShowConfirm(true);
  };

  const confirmarEliminacion = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/control-entregas/${idAEliminar}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setBeneficios(prev => prev.filter(b => b._id !== idAEliminar));
      toast.success("Beneficio eliminado correctamente");
    } catch (error) {
      console.error("❌ Error al eliminar beneficio:", error);
      toast.error("Error al eliminar beneficio");
    }
    setShowConfirm(false);
    setIdAEliminar(null);
  };

  // === Excel ===
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          cellDates: true,
        });

        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
          defval: "",
          raw: false,
        });

        const dataFormateada = jsonData.map((row) => ({
          ...row,
          FECHA: excelDateToJS(row.FECHA),
        }));

        if (!jsonData || jsonData.length === 0) {
          toast.warn("El archivo Excel está vacío o mal estructurado.");
          return;
        }

        // ✅ VALIDACIÓN AQUÍ (ya existe jsonData)
        const erroresExcel = validarFilasExcel(dataFormateada);

        if (erroresExcel.length > 0) {
          toast.error("El archivo contiene errores y no puede importarse");

          console.group("Errores en Excel");
          erroresExcel.forEach(e => console.error(e));
          console.groupEnd();

          setErroresExcelModal(erroresExcel);
          setShowErrorModal(true);
          return;

        }

        // ✅ SOLO SI PASA VALIDACIÓN
        setImportRows(dataFormateada);
        setShowImportModal(true);

      } catch (error) {
        console.error("❌ Error leyendo archivo:", error);
        toast.error("Error al leer el archivo.");
      }
    };

    reader.readAsArrayBuffer(file);

    // Permite volver a seleccionar el mismo archivo
    e.target.value = "";
  };

  const exportToExcel = () => {
    const dataExport = beneficiosFiltrados.map(b => ({
      "CÉDULA": b["CÉDULA"],
      "ASOCIADO": b["ASOCIADO"],
      "EMPRESA": b["EMPRESA"],
      "CIUDAD": b["CIUDAD"],
      "COSTOS": b["COSTOS"],
      "FECHA": b["FECHA"],
      "ÁREA": b["ÁREA"],
      "TIPO": b["TIPO"],
      "PROGRAMA": b["PROGRAMA"],
      "INTERNO": b["INTERNO"],      // ✅ CORRECTO
      "ENVÍO": b["ENVÍO"],
      "TOTAL": b["TOTAL"],
      "COMERCIAL": b["COMERCIAL"],
      "TRANSFERENCIA": b["TRANSFERENCIA"],
    }));

    const ws = XLSX.utils.json_to_sheet(dataExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Beneficios");
    XLSX.writeFile(wb, "Beneficios_Listado.xlsx");
  };


  const formatoTitulo = (texto) =>
    texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase(
    );


  const editarBeneficio = (beneficio) => {
    setNuevoBeneficio({ ...beneficio });
    setModoEdicion(true);
    setShowModal(true);
  };


  const actualizarBeneficio = async () => {
    try {
      const id = nuevoBeneficio._id;

      const payload = {
        cedula: nuevoBeneficio["CÉDULA"],
        asociado: nuevoBeneficio["ASOCIADO"],
        empresa: nuevoBeneficio["EMPRESA"],
        ciudad: nuevoBeneficio["CIUDAD"],
        costos: Number(nuevoBeneficio["COSTOS"]) || 0,
        fecha: nuevoBeneficio["FECHA"],
        area: nuevoBeneficio["ÁREA"],
        tipo: nuevoBeneficio["TIPO"],
        programa: nuevoBeneficio["PROGRAMA"],
        monto: Number(nuevoBeneficio["MONTO"]) || 0,
        envio: Number(nuevoBeneficio["ENVÍO"]) || 0,
        total: Number(nuevoBeneficio["TOTAL"]) || 0,
        comercial: Number(nuevoBeneficio["COMERCIAL"]) || 0,
        interno: Number(nuevoBeneficio["INTERNO"]) || 0,
        transferencia: Number(nuevoBeneficio["TRANSFERENCIA"]) || 0,
        excedentes: Number(nuevoBeneficio["EXCEDENTES"]) || 0,
      };

      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/control-entregas/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // 🟣 ACTUALIZAR EN LISTA SIN DUPLICAR
      setBeneficios(prev =>
        prev.map(b => (b._id === id ? { ...nuevoBeneficio, _id: id } : b))
      );

      toast.success("Beneficio actualizado correctamente");
      cerrarModal();
    } catch (error) {
      console.error("❌ Error al actualizar beneficio:", error);
      toast.error("Error al actualizar beneficio");
    }
  };

  const [showConfirm, setShowConfirm] = useState(false);
  const [idAEliminar, setIdAEliminar] = useState(null);

  const confirmarImportacion = async () => {
    if (importRows.length === 0) return;

    try {
      setImportLoading(true);

      // 🔹 Opción A (rápida de implementar): POST fila por fila en paralelo
      const requests = importRows.map((row) => {
        const payload = {
          cedula: row["CÉDULA"] || row["Cedula"] || "",
          asociado: row["ASOCIADO"] || "",
          empresa: row["EMPRESA"] || "",
          ciudad: row["CIUDAD"] || "",
          costos: Number(row["COSTOS"]) || 0,
          fecha: row["FECHA"] || "",
          area: row["ÁREA"] || row["AREA"] || "",
          tipo: row["TIPO"] || "",
          programa: row["PROGRAMA"] || "",
          monto: 0, // ya no se usa
          interno: Number(row["INTERNO"]) || 0, // ✅ AQUÍ
          envio: Number(row["ENVÍO"] || row["ENVIO"]) || 0,
          total: Number(row["TOTAL"]) || 0,
          comercial: Number(row["COMERCIAL"]) || 0,
          transferencia: Number(row["TRANSFERENCIA"]) || 0,
          excedentes: Number(row["EXCEDENTES"]) || 0,
        };


        return axios.post(
          `${process.env.REACT_APP_API_URL}/api/control-entregas`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

      });

      await Promise.all(requests);

      // ✅ Refresca desde backend
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/control-entregas`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (Array.isArray(res.data)) {
        const adaptados = res.data.map((b) => ({
          _id: b._id,
          "CÉDULA": b["Cédula"] || "",
          "ASOCIADO": b["Asociado"] || "",
          "EMPRESA": b["Empresa"] || "",
          "CIUDAD": b["Ciudad"] || "",
          "COSTOS": b["Costos"] || "",
          "FECHA": b["Fecha"] || "",
          "ÁREA": b["Área"] || "Sin área",
          "TIPO": b["Tipo"] || "Sin tipo",
          "PROGRAMA": b["Programa"] || "Sin programa",
          "MONTO": parseFloat((b["Monto"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          "ENVÍO": parseFloat((b["Envío"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          "TOTAL": parseFloat((b["Total"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          "COMERCIAL": parseFloat((b["Comercial"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          "INTERNO": parseFloat((b["Interno"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          "TRANSFERENCIA": parseFloat((b["Transferencia"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
          "EXCEDENTES": parseFloat((b["Excedentes"] || "0").toString().replace(/\./g, "").replace(",", ".")) || 0,
        }));
        setBeneficios(adaptados);
      }

      toast.success(`✅ Importación lista: ${importRows.length} registros`);
      cerrarImportModal();
    } catch (error) {
      console.error("❌ Error importando:", error);
      toast.error("Error al importar el archivo.");
    } finally {
      setImportLoading(false);
    }
  };

  const cerrarImportModal = () => {
    setShowImportModal(false);
    setImportRows([]);
    setImportLoading(false);
  };

  const programasDisponibles = useMemo(() => {
    const area = nuevoBeneficio["ÁREA"];
    const tipo = nuevoBeneficio["TIPO"];

    if (!area || !tipo) return [];
    return BENEFICIOS_MAP[area]?.[tipo] || [];
  }, [nuevoBeneficio["ÁREA"], nuevoBeneficio["TIPO"]]);

  const areasDisponibles = useMemo(() => {
    if (!nuevoBeneficio.TIPO) return [];

    return Object.keys(BENEFICIOS_MAP).filter((area) =>
      BENEFICIOS_MAP[area][nuevoBeneficio.TIPO]
    );
  }, [nuevoBeneficio.TIPO]);

  const validarFormulario = () => {
    const nuevosErrores = {};

    // Campos generales obligatorios
    CAMPOS_OBLIGATORIOS_EXCEL.forEach((campo) => {
      if (
        nuevoBeneficio[campo] === undefined ||
        nuevoBeneficio[campo] === null ||
        String(nuevoBeneficio[campo]).trim() === ""
      ) {
        nuevosErrores[campo] = "Este campo es obligatorio";
      }
    });

    // 🟣 COMPRA obligatoria SOLO para Comerciales
    if (nuevoBeneficio.TIPO === "Comerciales") {
      if (
        nuevoBeneficio.COMPRA === undefined ||
        nuevoBeneficio.COMPRA === null ||
        String(nuevoBeneficio.COMPRA).trim() === ""
      ) {
        nuevosErrores.COMPRA = "Este campo es obligatorio";
      }
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const validarFilasExcel = (rows) => {
    const errores = [];

    rows.forEach((row, index) => {
      const fila = index + 2;

      // ✅ USAR LOS CAMPOS DEL EXCEL
      CAMPOS_OBLIGATORIOS_EXCEL.forEach((campo) => {
        if (
          row[campo] === undefined ||
          row[campo] === null ||
          String(row[campo]).trim() === ""
        ) {
          errores.push(`Fila ${fila}: el campo "${campo}" está vacío`);
        }
      });

      // Fecha válida
      if (row.FECHA && isNaN(new Date(row.FECHA).getTime())) {
        errores.push(`Fila ${fila}: la fecha "${row.FECHA}" no es válida`);
      }

      const area = row["ÁREA"];
      const tipo = row["TIPO"];
      const programa = row["PROGRAMA"];

      if (area && !BENEFICIOS_MAP[area]) {
        errores.push(`Fila ${fila}: el área "${area}" no existe`);
        return;
      }

      if (area && tipo && !BENEFICIOS_MAP[area][tipo]) {
        errores.push(
          `Fila ${fila}: el tipo "${tipo}" no corresponde al área "${area}"`
        );
        return;
      }

      if (
        area &&
        tipo &&
        programa &&
        !BENEFICIOS_MAP[area][tipo]?.includes(programa)
      ) {
        errores.push(
          `Fila ${fila}: el programa "${programa}" no corresponde al área "${area}" y tipo "${tipo}"`
        );
      }
    });

    return errores;
  };


  return (

    <>

    <PageTitle title="Beneficios" />

    <div className="beneficios-container">

      {/* ===== HEADER ===== */}
      <header className="ben-header">
        <h2>| Beneficios</h2>

        <div className="ben-actions">

          <button className="ben-btn-excel" onClick={exportToExcel}>
            <FiDownload size={15} />
            Exportar Excel
          </button>

          <button
            type="button"
            className="ben-btn-primary"
            onClick={() => fileInputRef.current?.click()}
          >
            <FiUpload size={15} />
            Registro masivo
          </button>

          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileUpload}
            hidden
          />

          <button className="ben-btn-primary" onClick={nuevoRegistro}>
            <FiHeart size={15} />
            Agregar beneficio
          </button>

        </div>
      </header>


      {/* === KPI === */}
      <div className="ben-kpi-container">

        <div className="ben-kpi-card total">

          <div className="ben-kpi-circle">
            <FiPackage size={24} />
          </div>

          <div className="ben-kpi-content">

            <div className="ben-kpi-title">
              N° de Beneficios
            </div>

            <div className="ben-kpi-value">
              {formatMoney(totalBeneficios)}
            </div>

          </div>

        </div>

        <div className="ben-kpi-card inversion">

          <div className="ben-kpi-circle">
            <FiDollarSign size={24} />
          </div>

          <div className="ben-kpi-content">

            <div className="ben-kpi-title">
              Inversión Social
            </div>

            <div className="ben-kpi-value">
              ${formatMoney(inversionSocial)}
            </div>

          </div>

        </div>

        <div className="ben-kpi-card envio">

          <div className="ben-kpi-circle">
            <FiCreditCard size={24} />
          </div>

          <div className="ben-kpi-content">

            <div className="ben-kpi-title">
              Costos de Envíos / Pagos
            </div>

            <div className="ben-kpi-value">
              ${formatMoney(totalEnvio)}
            </div>

          </div>

        </div>

        <div className="ben-kpi-card transferencia">

          <div className="ben-kpi-circle">
            <FiTrendingUp size={24} />
          </div>

          <div className="ben-kpi-content">

            <div className="ben-kpi-title">
              Transferencia Solidaria
            </div>

            <div className="ben-kpi-value">
              ${formatMoney(totalTransferencias)}
            </div>

          </div>

        </div>

      </div>

      {/* === FILTROS === */}
      <div className="ben-filters">
        <div className="ben-row">
          <div className="ben-field">
            <FiSearch className="ben-icon" />
            <input
              type="text"
              name="busqueda"
              placeholder="Buscar asociado…"
              value={filtros.busqueda}
              onChange={handleFiltro}
            />
          </div>

          <select name="ciudad" value={filtros.ciudad} onChange={handleFiltro}>
            <option value="">Todas las ciudades</option>
            {opcionesUnicas("CIUDAD").map((c, i) => (
              <option key={i}>{c}</option>
            ))}
          </select>

          <select name="empresa" value={filtros.empresa} onChange={handleFiltro}>
            <option value="">Todas las empresas</option>
            {opcionesUnicas("EMPRESA").map((c, i) => (
              <option key={i}>{c}</option>
            ))}
          </select>

          <select name="area" value={filtros.area} onChange={handleFiltro}>
            <option value="">Todas las áreas</option>
            {areas.map((a, i) => (
              <option key={i}>{a}</option>
            ))}
          </select>

          <select name="tipo" value={filtros.tipo} onChange={handleFiltro}>
            <option value="">Todos los tipos</option>
            {tipos.map((t, i) => (
              <option key={i}>{t}</option>
            ))}
          </select>

          <select name="programa" value={filtros.programa} onChange={handleFiltro}>
            <option value="">Todos los programas</option>
            {programas.map((p, i) => (
              <option key={i}>{p}</option>
            ))}
          </select>

          <div className="calendar-container">
            <button
              type="button"
              className="ben-date-select"
              onClick={() => setShowCalendar(!showCalendar)}
            >
              {filtros.fechaInicio && filtros.fechaFin
                ? `${filtros.fechaInicio} → ${filtros.fechaFin}`
                : "Filtrar por fecha"}
            </button>

            {showCalendar && (
              <div className="calendar-popover">
                <DateRange
                  editableDateInputs={true}
                  onChange={handleSelectFecha}
                  moveRangeOnFirstSelection={false}
                  ranges={rangoFecha}
                  locale={es}
                />
              </div>
            )}
          </div>

          <button
            type="button"
            className="obs-btn-ghost"
            onClick={resetFiltros}
          >
            Restablecer
          </button>
        </div>
      </div>


      {/* === TABLA === */}
      <div className="ben-table">
        <table>
          <thead>
            <tr>
              <th>Identificación</th>
              <th>Nombre</th>
              <th>Empresa</th>
              <th>Ciudad</th>
              <th>Costos</th>
              <th>Fecha</th>
              <th>Área</th>
              <th>Tipo</th>
              <th>Programa</th>

              {/* CAMPOS NUMÉRICOS */}
              <th>Interno</th>
              <th>Envío</th>
              <th>Total</th>
              <th>Comercial</th>
              <th>Transferencia</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {registrosMostrados.length > 0 ? (
              registrosMostrados.map((b, i) => (
                <tr key={i}>

                  {/* CAMPOS DE TEXTO */}
                  <td>{b["CÉDULA"]}</td>
                  <td>{b["ASOCIADO"]}</td>
                  <td className="truncate-cell" title={b["EMPRESA"]}>
                    {b["EMPRESA"]}
                  </td>
                  <td>{b["CIUDAD"]}</td>
                  <td>{b["COSTOS"]}</td>
                  <td>{b["FECHA"]}</td>
                  <td>{b["ÁREA"]}</td>
                  <td>{b["TIPO"]}</td>
                  <td className="truncate-cell">
                    {b["PROGRAMA"]?.replace(/^\d+\s*-\s*/, "")}
                  </td>

                  {/* CAMPOS NUMÉRICOS → FORMATO COLOMBIANO */}
                  <td>{formatMoney(b["INTERNO"])}</td>
                  <td>{formatMoney(b["ENVÍO"])}</td>
                  <td>{formatMoney(b["TOTAL"])}</td>
                  <td>{formatMoney(b["COMERCIAL"])}</td>
                  <td>{formatMoney(b["TRANSFERENCIA"])}</td>

                  {/* ACCIONES */}
                  <td className="ben-actions">
                    <button
                      className="ben-icon-btn"
                      onClick={() => editarBeneficio(b)}
                      title="Modificar"
                    >
                      <FiEdit2 size={15} />
                    </button>
                    <button
                      className="ben-icon-btn"
                      onClick={() => eliminarBeneficio(b._id)}
                      title="Eliminar"
                    >
                      <FiTrash2 size={15} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="17" className="ben-empty">
                  No hay beneficios registrados
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* PAGINACIÓN */}
        <div className="ben-pagination">
          <button
            onClick={() => setPaginaActual((p) => Math.max(p - 1, 1))}
            disabled={paginaActual === 1}
          >
            Anterior
          </button>

          <span className="info">
            Página {paginaActual} de {totalPaginas}
          </span>

          <button
            onClick={() => setPaginaActual((p) => Math.min(p + 1, totalPaginas))}
            disabled={paginaActual === totalPaginas}
          >
            Siguiente
          </button>
        </div>
      </div>



      {/* === MODAL === */}
      {showModal && (
        <div className="ben-modal-overlay" onClick={cerrarModal}>
          <div className="modal moderno" onClick={(e) => e.stopPropagation()}>
            <h3>{nuevoBeneficio._id ? "Modificación de Beneficio" : "Registro de Nuevo Beneficio"}</h3>

            <h4 className="subtitulo">Datos generales</h4>
            <div className="modal-grid-4">
              {["CÉDULA", "ASOCIADO", "EMPRESA", "CIUDAD", "COSTOS"].map(
                (campo, i) => (
                  <div key={i} className="campo">
                    <label>{formatoTitulo(campo)}</label>
                    <input
                      type="text"
                      name={campo}
                      value={nuevoBeneficio[campo]}
                      onChange={handleChange}
                    />
                    {errores[campo] && <small className="error-text">{errores[campo]}</small>}
                  </div>
                )
              )}

              <div className="campo">
                <label>Fecha</label>
                <input
                  type="date"
                  name="FECHA"
                  value={nuevoBeneficio["FECHA"]}
                  onChange={handleChange}
                />
                {errores["FECHA"] && <small className="error-text">{errores["FECHA"]}</small>}
              </div>

              <div className="campo">
                <label>Tipo</label>
                <select name="TIPO" value={nuevoBeneficio.TIPO} onChange={handleChange}>
                  <option value="">Seleccione...</option>
                  {Object.values(BENEFICIOS_MAP)
                    .flatMap(obj => Object.keys(obj))
                    .filter((v, i, a) => a.indexOf(v) === i)
                    .map(t => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                </select>
              </div>

              <div className="campo">
                <label>Área</label>
                <select
                  name="ÁREA"
                  value={nuevoBeneficio["ÁREA"]}
                  onChange={handleChange}
                  disabled={!nuevoBeneficio.TIPO}
                >
                  <option value="">Seleccione...</option>
                  {areasDisponibles.map(a => (
                    <option key={a} value={a}>{a}</option>
                  ))}
                </select>
              </div>

              <div className="campo">
                <label>Programa</label>
                <select
                  name="PROGRAMA"
                  value={nuevoBeneficio["PROGRAMA"]}
                  onChange={handleChange}
                  disabled={!nuevoBeneficio["TIPO"]}
                >
                  <option value="">Seleccione...</option>
                  {programasDisponibles.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
                {errores["PROGRAMA"] && <small className="error-text">{errores["PROGRAMA"]}</small>}
              </div>
            </div>

            <h4 className="subtitulo">Valores</h4>
            <div className="modal-grid-4">
              {nuevoBeneficio.TIPO === "Sociales" && (
                <>
                  <CampoNumero
                    label="Interno"
                    name="INTERNO"
                    value={nuevoBeneficio.INTERNO}
                    onChange={handleChange}
                    error={errores.INTERNO}
                  />

                  <CampoNumero
                    label="Envío"
                    name="ENVÍO"
                    value={nuevoBeneficio["ENVÍO"]}
                    onChange={handleChange}
                    error={errores["ENVÍO"]}
                  />

                  <CampoNumero
                    label="Total"
                    name="TOTAL"
                    value={nuevoBeneficio.TOTAL}
                    readOnly
                  />

                  <CampoNumero
                    label="Transferencia"
                    name="TRANSFERENCIA"
                    value={nuevoBeneficio.TRANSFERENCIA}
                    readOnly
                  />

                  <CampoNumero
                    label="Comercial"
                    name="COMERCIAL"
                    value={nuevoBeneficio.COMERCIAL}
                    onChange={handleChange}
                    error={errores.COMERCIAL}
                  />
                </>
              )}


              {nuevoBeneficio.TIPO === "Comerciales" && (
                <>
                  <CampoNumero
                    label="Comercial"
                    name="COMERCIAL"
                    value={nuevoBeneficio.COMERCIAL}
                    onChange={handleChange}
                    error={errores.COMERCIAL}
                  />

                  <CampoNumero
                    label="Compra"
                    name="COMPRA"
                    value={nuevoBeneficio.COMPRA}
                    onChange={handleChange}
                    error={errores.COMPRA}
                  />

                  <CampoNumero
                    label="Transferencia"
                    name="TRANSFERENCIA"
                    value={nuevoBeneficio.TRANSFERENCIA}
                    readOnly
                  />
                </>
              )}

              {["Aportes", "Captaciones", "Cartera"].includes(nuevoBeneficio.TIPO) && (
                <CampoNumero
                  label="Transferencia"
                  name="TRANSFERENCIA"
                  value={nuevoBeneficio.TRANSFERENCIA}
                  onChange={handleChange}
                  error={errores.TRANSFERENCIA}
                />
              )}
            </div>

            <div className="modal-actions">
              <button className="ben-btn-secondary" onClick={cerrarModal}>
                Cancelar
              </button>
              <button
                className="ben-btn-primary"
                onClick={() => {
                  if (!validarFormulario()) {
                    toast.warn("Completa los campos obligatorios");
                    return;
                  }

                  if (modoEdicion) {
                    actualizarBeneficio();
                  } else {
                    guardarBeneficio();
                  }
                }}

              >
                {nuevoBeneficio._id ? "Modificar beneficio" : "Registrar beneficio"}
              </button>

            </div>
          </div>
        </div>
      )}

      {showConfirm && (
        <div className="modal-overlay" onClick={() => setShowConfirm(false)}>

          <div className="ben-confirm-modal" onClick={(e) => e.stopPropagation()}>

            <h3>¿Eliminar beneficio?</h3>

            <p>Esta acción no se puede deshacer.</p>

            <div className="modal-actions" style={{ gap: "15px" }}>
              <button className="ben-btn-secondary" onClick={() => setShowConfirm(false)}>
                Cancelar
              </button>

              <button className="ben-btn-danger" onClick={confirmarEliminacion}>
                Eliminar
              </button>
            </div>

          </div>
        </div>
      )}

      {showImportModal && (
        <div className="modal-overlay" onClick={cerrarImportModal}>
          <div className="modal moderno" onClick={(e) => e.stopPropagation()}>
            <h3>Importación Masiva de Beneficios</h3>

            <p style={{ marginTop: 6, opacity: 0.85 }}>
              Vista previa ({importRows.length} registros)
            </p>

            <div style={{ maxHeight: 320, overflow: "auto", marginTop: 10 }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {Object.keys(importRows[0] || {}).slice(0, 16).map((k) => (
                      <th key={k} style={{ textAlign: "left", padding: "8px" }}>
                        {k}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {importRows.slice(0, 8).map((r, i) => (
                    <tr key={i}>
                      {Object.keys(importRows[0] || {}).slice(0, 16).map((k) => (
                        <td key={k} style={{ padding: "8px", borderTop: "1px solid #eee" }}>
                          {String(r[k] ?? "")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="modal-actions" style={{ marginTop: 14 }}>
              <button className="btn-secondary" onClick={cerrarImportModal}>
                Cancelar
              </button>

              <button
                className="btn-primary"
                onClick={confirmarImportacion}
                disabled={importLoading || importRows.length === 0}
              >
                {importLoading ? "Importando..." : "Confirmar importación"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showErrorModal && (
        <div className="modal-overlay" onClick={() => setShowErrorModal(false)}>
          <div className="modal moderno" onClick={(e) => e.stopPropagation()}>
            <h3>Errores en el archivo Excel</h3>

            <p style={{ opacity: 0.8, marginBottom: 10 }}>
              Corrige los siguientes errores antes de importar:
            </p>

            <div style={{ maxHeight: 300, overflowY: "auto" }}>
              <ul style={{ paddingLeft: 18 }}>
                {erroresExcelModal.map((err, i) => (
                  <li key={i} style={{ marginBottom: 6 }}>
                    {err}
                  </li>
                ))}
              </ul>
            </div>

            <div className="modal-actions">
              <button
                className="btn-primary"
                onClick={() => setShowErrorModal(false)}
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}

    </div>

    </>
    
  );
}

export default Beneficios360;
